import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Button from '@wix/da-ds/pkg/Buttons/GhostButton';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import WidgetBoxWrapper from '../WidgetBox/_partials/WidgetBoxWrapper';
import WidgetEditControls from '../WidgetBox/_partials/WidgetEditControls';
import WidgetHeaderWide from '../WidgetBox/lego/WidgetHeaderWide';
import WidgetHeaderMobile from '../WidgetBox/lego/WidgetHeaderMobile';
import useGruser from '../../hooks/useGruser';
import s from './WidgetBoxWide.scss';
const WidgetBoxWide = ({ moduleId, isEmpty, emptyView, children, id, className, parentRef, header, subHeader, count, isHeaderStickyOnMobile, headerExtraElementsOnMobile, hasMore, isFetching, fetchMore, biggerHeader = false, confirmRemove, configPopoverComponent })=>{
    const { gruser } = useGruser();
    const isMobile = useContext(MobileContext);
    const { t } = useTranslation();
    if (!gruser) {
        return null;
    }
    if (isEmpty && !emptyView) {
        return null;
    }
    const renderHeaderExtraElements = ()=>{
        return /*#__PURE__*/ React.createElement(WidgetEditControls, {
            moduleId: moduleId,
            configPopoverComponent: configPopoverComponent,
            confirmRemove: confirmRemove
        });
    };
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "WidgetBoxWide"
    }, /*#__PURE__*/ React.createElement(WidgetBoxWrapper, {
        id: id,
        className: c(s['widget-wrapper'], className),
        ref: parentRef,
        "data-moduleid": moduleId,
        "data-userid": gruser.gruserId
    }, isMobile ? /*#__PURE__*/ React.createElement(WidgetHeaderMobile, {
        header: header,
        count: count,
        isSticky: isHeaderStickyOnMobile,
        extras: headerExtraElementsOnMobile,
        className: s['widget-header'],
        isWide: true
    }) : /*#__PURE__*/ React.createElement(WidgetHeaderWide, {
        header: header,
        subHeader: subHeader,
        extras: renderHeaderExtraElements(),
        bigger: biggerHeader
    }), /*#__PURE__*/ React.createElement(React.Fragment, null, isEmpty ? emptyView : children), !isEmpty && hasMore && /*#__PURE__*/ React.createElement(Button, {
        size: "large",
        variant: "main",
        disabled: isFetching,
        className: s['view-more-button'],
        onClick: fetchMore,
        biData: {
            evid: BiEventType.PROFILE_LOAD_MORE_CLICK,
            typeid: 4,
            itemid: gruser.gruserId
        }
    }, t('common.loadMore'))));
};
WidgetBoxWide.displayName = 'WidgetBoxWide';
export default WidgetBoxWide;
